import { Button, Space } from 'antd';
import React, { useState } from 'react';
import styled from 'styled-components';
import { CollectFilled } from '@assets';
import { useNavigate } from 'react-router-dom';
import { PRIVATE_ROUTE } from '@router/route.constants';
import { api } from '@api';
import { useDispatch } from 'react-redux';
import { openAlert } from "@redux/app/appSlice";
import { Alert } from '@components';
import { useTranslation } from 'react-i18next';

const Card = styled.div`
margin-bottom: 16px;
padding: 12px;
display: flex;
align-items: center;
gap: 12px;
border-radius: 8px;
border: 1px solid #E6E6E6;
background: #fff;

svg {
    min-width: 44px;
    height: 44px;
}

@media screen and (max-width: 325px) {
    padding: 6px 4px;
    gap: 4px;
}
`;

const Content = styled.div`
flex: 1;
display: flex;
flex-direction: column;
gap: 4px;
align-items: flex-start;
justify-content: center;
overflow: hidden;
position: relative;

.ant-space {
    gap: 0 !important;
    align-items: flex-end;
}
`;

const Title = styled.div`
font-size: 14px;
font-weight: 700;
color: ${props => props.theme.primaryColor};
line-height: 1.5;

@media screen and (max-width: 325px) {
    font-size: 12px;
}
`;

const Text = styled.div`
font-size: 12px;
font-weight: 400;
color: #565656;
line-height: 2;
cursor: pointer;

width: 100%;
overflow: hidden;
display: ${props => props.showAll === 'true' ? "block" : "-webkit-box"};
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /* start showing ellipsis when 2nd line is reached */
  white-space: pre-wrap; /* let the text wrap preserving spaces */

  @media screen and (max-width: 325px) {
    font-size: 11px;
}
`;

const ActionButton = styled(Button).attrs({
    type: 'primary',
})`
padding: 4px 12px !important;
width: auto !important;
height: auto !important;
font-size: 12px !important;
font-weight: 700 !important;
line-height: 1.5 !important;
box-shadow: none !important;

@media screen and (max-width: 325px) {
    font-size: 11px !important;
}

:disabled {
    background-color: #DEDEDE !important;
    color: #ABABAB !important;
}
`;

const MoreButton = styled(Button).attrs({
    type: 'primary',
})`
position: absolute;
top: 0;
right: 0;

padding: 4px 8px !important;
min-width: 29px !important;
width: auto !important;
height: auto !important;
font-size: 10px !important;
font-weight: 700 !important;
line-height: 1.5 !important;

@media screen and (max-width: 325px) {
    font-size: 9px !important;
}
`;

const CollectCard = ({
    item,
    moreCount = 0,
    successCallback,
}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [isMoreClicked, setIsMoreClicked] = useState(false);

    const collect = () => {
        if (!loading) {
            setLoading(true);
            api
                .thawBalance({
                    freeze_balance_id: item.freeze_balance_id,
                })
                .then(() => {
                    setLoading(false);
                    showAlert({
                        message: t("freezeBalance.successMessage"),
                        successCallback: () => successCallback(item.freeze_balance_id),
                    });
                })
                .catch((error) => {
                    setLoading(false);
                    showAlert({
                        message: error.message || error,
                        isError: true,
                    });
                });
        }
    }

    const showAlert = (data) => {
        dispatch(openAlert(data));
    };

    const seeMore = () => {
        navigate(`/${PRIVATE_ROUTE.FREEZE_BALANCES}`);
    }

    return (
        <>
            <Card>
                <CollectFilled />
                <Content>
                    {moreCount > 0 &&
                        <MoreButton onClick={seeMore}>
                            {`+${moreCount}`}
                        </MoreButton>
                    }
                    <Title>{t("freezeBalance.title")}</Title>
                    <Space>
                        <Text
                            showAll={isMoreClicked ? "true" : "false"}
                            onClick={() => setIsMoreClicked(prev => !prev)}
                        >
                            {t("freezeBalance.message", {
                                game_name: item.name_en
                            })}
                        </Text>
                    </Space>
                    <ActionButton
                        disabled={loading}
                        onClick={collect}
                    >
                        {t("freezeBalance.collect")}
                    </ActionButton>
                </Content>
            </Card>
            <Alert />
        </>
    );
}

export default CollectCard;